
import React, { useEffect, useState, useContext } from "react";
import { CartContext } from "../context/CartContext";
import "./Products.css";
import { useLocation } from "react-router-dom";

export default function Products() {
  const location = useLocation();

  // ================= STATES =================

  const [products, setProducts] = useState([]);

const { addToCart } = useContext(CartContext);

  const [activeCategory, setActiveCategory] = useState("");

const [selectedImages, setSelectedImages] = useState({});
const [selectedVideos, setSelectedVideos] = useState({});
const [mediaType, setMediaType] = useState({});

  const [quantities, setQuantities] = useState({});

  const [loading, setLoading] = useState(true);

  // LOGIN

  const [showLogin, setShowLogin] = useState(false);

  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");


  // UPLOAD

  const [showUpload, setShowUpload] = useState(false);

  const [productName, setProductName] = useState("");

  const [category, setCategory] = useState("");

  const [description, setDescription] = useState("");

  const [images, setImages] = useState([]);

  const [videos, setVideos] = useState([]);

  const [popupImage, setPopupImage] = useState("");

  // ================= FETCH PRODUCTS =================

const fetchProducts = React.useCallback(() => {

fetch(
  "https://omkarabrasives.in/api/get_products.php",
  {
    cache: "no-store"
  }
)

      .then((res) => res.json())

      .then((data) => {

        console.log("Products:", data);

        if (Array.isArray(data)) {

          setProducts(data);

          const uniqueCategories = [
            ...new Set(data.map((p) => p.category))
          ];

if (location.state?.activeTab) {

  setActiveCategory(
    location.state.activeTab
  );

} else if (
  uniqueCategories.includes("Powders")
) {

  setActiveCategory("Powders");

} else if (uniqueCategories.length > 0) {

  setActiveCategory(uniqueCategories[0]);

}
else if (uniqueCategories.length > 0) {

  setActiveCategory(uniqueCategories[0]);

}

        }

        setLoading(false);

      })

      .catch((err) => {

        console.error(err);

        setLoading(false);

      });

  }, [location.state]);

useEffect(() => {

  fetchProducts();

}, [fetchProducts]);

  // ================= CATEGORIES =================

const allCategories = [
  ...new Set(products.map((p) => p.category))
];

const priorityCategories = [
  "Powders",
  "Production"
];

const remainingCategories =
  allCategories.filter(
    (cat) =>
      !priorityCategories.includes(cat)
  );

const categories = [
  ...priorityCategories,
  ...remainingCategories
];

  // ================= FILTER PRODUCTS =================

const filteredProducts = products
  .filter(
    (product) =>
      product.category === activeCategory
  );

const selectedProductId =
  location.state?.selectedProductId;
useEffect(() => {

  if (selectedProductId) {

    setTimeout(() => {

      const element = document.getElementById(
        `product-${selectedProductId}`
      );

      if (element) {

        element.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

      }

    }, 400);

  }

}, [selectedProductId, filteredProducts]);
  // ================= LOGIN =================

  const handleLogin = async () => {

    const response = await fetch(
      "https://omkarabrasives.in/api/login.php",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify({
          username,
          password
        })
      }
    );

    const data = await response.json();

    alert(data.message);

    if (data.success) {


      setShowLogin(false);

      setShowUpload(true);

    }

  };

  // ================= UPLOAD PRODUCT =================

  const handleUpload = async () => {

    const formData = new FormData();

    formData.append("name", productName);

    formData.append("category", category);

    formData.append("description", description);

    // MULTIPLE IMAGES

    for (let i = 0; i < images.length; i++) {

      formData.append("images[]", images[i]);

    }

    // MULTIPLE VIDEOS

    for (let i = 0; i < videos.length; i++) {

      formData.append("videos[]", videos[i]);

    }

    const response = await fetch(
      "https://omkarabrasives.in/api/upload_product.php",
      {
        method: "POST",
        body: formData
      }
    );

    const data = await response.json();

    alert(data.message);

    if (data.success) {


      fetchProducts();

    }

  };

  // ================= UI =================

  return (

    <div className="products-page">

      {/* HERO */}

      <section className="products-hero">

        <h1>OUR PRODUCTS</h1>

        <p>

          Industrial Abrasives & Ceramic Solutions

        </p>

      </section>

      {/* CATEGORY TABS */}

      <div className="category-tabs">

        {categories.map((category, index) => (

          <button
            key={index}
            className={
              activeCategory === category
                ? "tab-btn active-tab"
                : "tab-btn"
            }
            onClick={() => setActiveCategory(category)}
          >

            {category}

          </button>

        ))}

      </div>

      {/* PRODUCTS */}

      {loading ? (

        <div className="loading-section">

          <h2>Loading Products...</h2>

        </div>

      ) : (

        <div className="products-container">

          {filteredProducts.map((product) => (

<div
  className={`product-card ${
    selectedProductId === product.id
      ? "active-product-card"
      : ""
  }`}
  key={product.id}
  id={`product-${product.id}`}
>

              {/* MEDIA */}

{/* MEDIA */}

<div className="product-media">

  {/* BUTTONS */}

  <div className="media-switch">

    <button
      className={
        (mediaType[product.id] || "photos") === "photos"
          ? "media-btn active-media-btn"
          : "media-btn"
      }
      onClick={() =>
        setMediaType((prev) => ({
          ...prev,
          [product.id]: "photos"
        }))
      }
    >
      Photos
    </button>

    <button
      className={
        mediaType[product.id] === "videos"
          ? "media-btn active-media-btn"
          : "media-btn"
      }
      onClick={() =>
        setMediaType((prev) => ({
          ...prev,
          [product.id]: "videos"
        }))
      }
    >
      Videos
    </button>

  </div>

  {/* MAIN MEDIA */}

  <div className="main-media-box">

    {(mediaType[product.id] || "photos") === "photos" ? (

<img
  src={
    selectedImages[product.id]
    || product.images?.[0]
  }
  alt={product.name}
  className="main-product-image"
  onClick={() =>
    setPopupImage(
      selectedImages[product.id]
      || product.images?.[0]
    )
  }
/>

    ) : (

<video
  key={
    selectedVideos[product.id]
    || product.videos?.[0]
  }
  controls
  className="main-product-video"
>

  <source
    src={
      selectedVideos[product.id]
      || product.videos?.[0]
    }
    type="video/mp4"
  />

</video>

    )}

  </div>

  {/* THUMBNAILS */}

  <div className="thumbnail-row">

    {(mediaType[product.id] || "photos") === "photos" ? (

      product.images?.map((image, index) => (

        <img
          key={index}
          src={image}
          alt="thumb"
          className={
            (
              selectedImages[product.id]
              || product.images?.[0]
            ) === image
              ? "thumbnail active-thumbnail"
              : "thumbnail"
          }
          onClick={() =>
            setSelectedImages((prev) => ({
              ...prev,
              [product.id]: image
            }))
          }
        />

      ))

    ) : (

product.videos?.map((video, index) => (

  <video
    key={index}
    className={
      (
        selectedVideos[product.id]
        || product.videos?.[0]
      ) === video
        ? "thumbnail active-thumbnail"
        : "thumbnail"
    }
    muted
    onClick={() =>
      setSelectedVideos((prev) => ({
        ...prev,
        [product.id]: video
      }))
    }
  >

    <source
      src={video}
      type="video/mp4"
    />

  </video>

))

    )}

  </div>

</div>

              {/* DETAILS */}

              <div className="product-details">

                <h2>{product.name}</h2>

                <ul>

                  {(product.description || "")
                    .split(".")
                    .filter(
                      (line) => line.trim() !== ""
                    )
                    .map((line, index) => (

                      <li key={index}>

                        {line.trim()}.

                      </li>

                    ))}

                </ul>
{/* CART SECTION */}


<div className="cart-section">

  <div className="cart-bottom-row">

    {/* QUANTITY */}

    <div className="quantity-selector">

      <button
        className="qty-btn"
        onClick={() =>
          setQuantities((prev) => ({
            ...prev,
            [product.id]:
              (prev[product.id] || 1) > 1
                ? (prev[product.id] || 1) - 1
                : 1
          }))
        }
      >
        −
      </button>

      <div className="qty-number">
        {quantities[product.id] || 1}
      </div>

      <button
        className="qty-btn"
        onClick={() =>
          setQuantities((prev) => ({
            ...prev,
            [product.id]:
              (prev[product.id] || 1) + 1
          }))
        }
      >
        +
      </button>

    </div>

    {/* ADD TO CART */}

    <button
      className="add-cart-btn"
      onClick={() => {

        const qty = quantities[product.id] || 1;

        for (let i = 0; i < qty; i++) {

          addToCart({
            _id: product.id,
            name: product.name,
            image: product.images?.[0],
            category: product.category,
            specification: ""
          });

        }

      }}
    >
      Add To Cart
    </button>

  </div>

</div>
              </div>

            </div>

          ))}

        </div>

      )}

      {/* LOGIN BUTTON */}

      <div className="admin-login-section">

        <button
          className="admin-login-btn"
          onClick={() => setShowLogin(true)}
        >

          Login To Upload

        </button>

      </div>

      {/* LOGIN POPUP */}

      {showLogin && (

        <div className="popup-overlay">

          <div className="popup-box">

            <h2>Staff Login</h2>

            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) =>
                setUsername(e.target.value)
              }
            />

            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
            />

            <button onClick={handleLogin}>

              Login

            </button>

<button
  className="popup-close-btn"
  onClick={() => setShowLogin(false)}
>
  ×
</button>

          </div>

        </div>

      )}

      {/* UPLOAD POPUP */}

      {showUpload && (

        <div className="popup-overlay">

          <div className="popup-box upload-popup">

            <h2>Upload Product</h2>

            <input
              type="text"
              placeholder="Product Name"
              value={productName}
              onChange={(e) =>
                setProductName(e.target.value)
              }
            />

            <input
              type="text"
              placeholder="Category"
              value={category}
              onChange={(e) =>
                setCategory(e.target.value)
              }
            />

            <textarea
              placeholder="Description"
              value={description}
              onChange={(e) =>
                setDescription(e.target.value)
              }
            />

            {/* IMAGES */}

<div className="upload-field">

  <input
    type="file"
    multiple
    id="imageUpload"
    hidden
    onChange={(e) =>
      setImages(e.target.files)
    }
  />

  <label
    htmlFor="imageUpload"
    className="upload-label"
  >
    Select Images
  </label>

  <p className="file-count">

    {images.length > 0
      ? `${images.length} image(s) selected`
      : "No images selected"}

  </p>

</div>

            {/* VIDEOS */}

<div className="upload-field">

  <input
    type="file"
    multiple
    id="videoUpload"
    hidden
    onChange={(e) =>
      setVideos(e.target.files)
    }
  />

  <label
    htmlFor="videoUpload"
    className="upload-label"
  >
    Select Videos
  </label>

  <p className="file-count">

    {videos.length > 0
      ? `${videos.length} video(s) selected`
      : "No videos selected"}

  </p>

</div>

            <button onClick={handleUpload}>

              Upload Product

            </button>

<button
  className="popup-close-btn"
  onClick={() => setShowUpload(false)}
>
  ×
</button>

          </div>

        </div>

      )}
{/* IMAGE POPUP */}

{popupImage && (

  <div
    className="image-popup-overlay"
    onClick={() => setPopupImage("")}
  >

    <img
      src={popupImage}
      alt="Full View"
      className="popup-full-image"
    />

    <button
      className="popup-close-image-btn"
      onClick={() => setPopupImage("")}
    >
      ×
    </button>

  </div>

)}


    </div>

  );

}
